import * as React from 'react'
import {useTheme} from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import {ReactJSXElement} from '@emotion/react/types/jsx-namespace'

interface Props {
  bk?: string
  variant?: 'contentLeft' | 'contentRight'
  icons: {icon: ReactJSXElement; title: string}[]
  content: () => ReactJSXElement
}

const ICON_GRID_AREAS = ['1 / 1 / 2 / 2', '1 / 3 / 2 / 4', '2 / 2 / 3 / 3']

const ContentAndIconsSection = ({
  bk,
  content: Content,
  icons,
  variant = 'contentLeft',
}: Props) => {
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('md'))

  const showLeftContent =
    variant === 'contentLeft' || (variant === 'contentRight' && matches)

  const showRightContent = variant === 'contentRight' && !matches

  const ContentContainer = () => (
    <Grid item xs={12} md={6}>
      <Content />
    </Grid>
  )
  return (
    <section>
      <Box
        sx={{
          background: bk ? `url(${bk});` : '#fff',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          py: {md: 14, xs: 7},
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={9}>
            {showLeftContent && (
              <>
                <ContentContainer />
                {!matches && (
                  <Grid item xs={12} md={1}>
                    <Divider orientation="vertical" />
                  </Grid>
                )}
              </>
            )}
            <Grid
              item
              xs={12}
              md={5}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(3, 1fr)',
                  gridTemplateRows: 'repeat(2, 1fr)',
                  gridColumnGap: 0,
                  gridRowGap: 0,
                  textAlign: 'center',
                  height: '20rem',
                }}
              >
                {icons.map(({icon, title}, index) => (
                  <Box key={title} sx={{gridArea: ICON_GRID_AREAS[index]}}>
                    {icon}
                    <Typography
                      variant="subtitle2"
                      gutterBottom
                      sx={{textTransform: 'uppercase', paddingTop: 2}}
                    >
                      {title}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Grid>
            {showRightContent && (
              <>
                {!matches && (
                  <Grid item xs={12} md={1}>
                    <Divider orientation="vertical" />
                  </Grid>
                )}
                <ContentContainer />
              </>
            )}
          </Grid>
        </Container>
      </Box>
    </section>
  )
}

export default ContentAndIconsSection
